import request2 from '@/request/request4.js'
// import cryptoRequest from '@/request/cryptoRequest'

const interfaceApi = {
  preorder: '/telecom/preorder',
  confirmOrder: '/telecom/confirmOrder',
  traceFail: 'v1/trace/fail'
}
export const preorder = (data) => {
  return request2.post(`${interfaceApi.preorder}`, {
    type: data.type,
    phone: data.phone,
    userAgent: data.userAgent,
    url: data.url
  })
}

export const confirmOrder = (data) => {
  return request2.post(`${interfaceApi.confirmOrder}`, {
    phone: data.phone,
    code: data.code,
    type: data.type
  })
}

export const failPost = (data) => {
  return request2.post(`${interfaceApi.traceFail}`, {
    click_id: data.clickId,
    event_type: data.eventType,
    fail_message: data.failMessage
  })
}
